export default __webpack_public_path__ + "static/media/desc.df55355f.svg";